(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/size-picker.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/size-picker.js');

'use strict';

const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  RadioButton = _svs$ui$reactForm.RadioButton;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const updateIndex = svs.gamePackage.redux.gamePackageSlice.actions.updateIndex;
const SizePicker = () => {
  const _useSelector = useSelector(state => state.gamePackage),
    activeIndex = _useSelector.activeIndex,
    sizes = _useSelector.sizes;
  const dispatch = useDispatch();
  return React.createElement("div", {
    className: "gp-size-picker-container"
  }, React.createElement(RadioGroup, {
    size: "200"
  }, sizes.map(_ref => {
    let label = _ref.label,
      price = _ref.price,
      index = _ref.index;
    return React.createElement(RadioButton, {
      checked: index === activeIndex,
      onChange: () => dispatch(updateIndex({
        activeIndex: index
      })),
      name: "size-picker[]",
      value: index,
      key: label
    }, "".concat(label, " ").concat(price, " kr"));
  })));
};
svs.gamePackage.components.SizePicker = SizePicker;

 })(window);